let language = {
    712307: "当前订单不支持发票下载功能。请从最近完成支付的订单中下载发票"
};

export { language }
